import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Amplify } from 'aws-amplify'
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import reducer from './reducers'
import middleware from './middleware'
import './libs/i18n'
import config from './utils/config'
import { initializeGA } from './utils/ga4'
import LoadingSpinner from './components/common/LoadingSpinner'
import ScrollToTop from './components/common/ScrollToTop'
import { COLTENE_BRANCH_UUID } from './actions/root'
import App from '../src/components'
import './index.scss'

if (typeof URL !== 'undefined' && typeof URL.canParse !== 'function') {
  URL.canParse = function (url, base) {
    try {
      new URL(url, base || window.location.href)
      return true
    } catch (e) {
      return false
    }
  }
}

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },

  API: {
    REST: {
      mySciCanApiGateway: { endpoint: config.apiGateway.URL, region: config.apiGateway.REGION },
      mySciCanTrackingApiGateway: { endpoint: config.trackingApiGateway.URL, region: config.apiGateway.REGION },
      mySciCanRecordsApiGateway: { endpoint: config.recordsApiGateway.URL, region: config.apiGateway.REGION },
      mySciCanTelemetryApiGateway: { endpoint: config.telemetryApiGateway.URL, region: config.apiGateway.REGION },
      mySciCanAdminApiGateway: { endpoint: config.adminApiGateway.URL, region: config.adminApiGateway.REGION || config.apiGateway.REGION },
      mySciCanApiGatewayStore: { endpoint: config.apiGatewayStore.URL, region: config.apiGateway.REGION },
      mySciCanApiGatewayAi: { endpoint: config.apiGatewayAi.URL, region: config.apiGateway.REGION },
    },
  },

  Storage: {
    S3: {
      bucket: config.s3.BUCKET,
      region: config.s3.REGION,
    },
  },
}

Amplify.configure(amplifyConfig)

export const store = createStore(reducer, middleware)

initializeGA()

const rootEl = document.getElementById('root')

createRoot(rootEl).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingSpinner />}>
      <Provider store={store}>
        <ToastContainer
          position="top-center"
          transition={Slide}
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Router>
          <ScrollToTop />
          <App />
        </Router>
      </Provider>
    </Suspense>
  </React.StrictMode>,
)

